import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'Building2',
      label: 'Proyectos Activos',
      value: stats?.activeProjects,
      color: 'var(--color-primary)'
    },
    {
      icon: 'Home',
      label: 'Total de Lotes',
      value: stats?.totalLots,
      color: 'var(--color-accent)'
    },
    {
      icon: 'CheckCircle2',
      label: 'Lotes Disponibles',
      value: stats?.availableLots,
      color: 'var(--color-success)'
    },
    {
      icon: 'TrendingUp',
      label: 'Proyectos Completados',
      value: stats?.completedProjects,
      color: 'var(--color-secondary)'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="card bg-card hover:elevation-3 transition-smooth"
        >
          <div className="flex items-center justify-between mb-4">
            <div
              className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: `${item?.color}15` }}
            >
              <Icon name={item?.icon} size={28} color={item?.color} />
            </div>
          </div>
          <p className="text-3xl md:text-4xl font-semibold text-foreground mb-2 data-text">
            {item?.value}
          </p>
          <p className="text-sm md:text-base text-muted-foreground">
            {item?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;